module.exports = __webpack_public_path__ + "static/media/photo29.65854b03.jpg";